(function () {
  document.querySelectorAll('.newsletter__form-container--klaviyo').forEach((container) => {
    const block = container.querySelector('.shopify-app-block');
    if (!block) return;

    function update() {
      const input = block.querySelector('input[type="email"]');
      const button = block.querySelector('.klaviyo-form-button, button[type="submit"]');

      if (input && getComputedStyle(input).display !== 'none') {
        container.dataset.klaviyoReady = 'true';
        container.classList.remove('is-klaviyo-success');
        return;
      }

      if (container.dataset.klaviyoReady === 'true') {
        const buttonHidden = !button || getComputedStyle(button).display === 'none';
        container.classList.toggle('is-klaviyo-success', buttonHidden);
      }
    }

    new MutationObserver(update).observe(block, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden'],
    });

    update();
  });
})();
